
export default {
    heading: "Open Sans,Arial,sans-serif",
    body: "Open Sans,Arial,sans-serif"
}
